export default __webpack_public_path__ + "076266e0cd87c6be02a241f9890bc8c1.jpg";